var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.876,
    height: 74.876,
    viewBox: "0 0 74.876 74.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_4",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M15.674,14.348h10.7a2.674,2.674,0,0,0,0-5.348h-10.7a2.674,2.674,0,1,0,0,5.348Z",
    transform: "translate(18.416 11.719)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M15.674,17.348h10.7a2.674,2.674,0,1,0,0-5.348h-10.7a2.674,2.674,0,1,0,0,5.348Z",
    transform: "translate(18.416 16.741)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M71.528,23.886V17.552a8.023,8.023,0,1,0-5.348,0v6.334a8.011,8.011,0,0,0-4.856,4.856H55.483V12.7a2.674,2.674,0,0,0-.783-1.891L46.677,2.783A2.672,2.672,0,0,0,44.786,2H26.067a2.673,2.673,0,0,0-2.674,2.674V7.348H17.552a8,8,0,1,0-10.2,10.2v6.334a8.022,8.022,0,1,0,5.348,0V17.552A8.011,8.011,0,0,0,17.552,12.7h5.841V39.438a2.674,2.674,0,0,0,5.348,0V7.348h10.7v8.022a2.673,2.673,0,0,0,2.674,2.674h8.022V39.438a2.674,2.674,0,0,0,5.348,0V34.09h5.841a8,8,0,1,0,10.2-10.2ZM10.022,34.09A2.674,2.674,0,1,1,12.7,31.416,2.677,2.677,0,0,1,10.022,34.09Zm0-21.393A2.674,2.674,0,1,1,12.7,10.022,2.677,2.677,0,0,1,10.022,12.7ZM44.786,8.456,49.027,12.7H44.786ZM68.854,7.348a2.674,2.674,0,1,1-2.674,2.674A2.677,2.677,0,0,1,68.854,7.348Zm0,26.741a2.674,2.674,0,1,1,2.674-2.674A2.677,2.677,0,0,1,68.854,34.09Z",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M47.917,26.879a16.024,16.024,0,0,0-30.351,0,13.339,13.339,0,0,0,1.805,26.559H46.112a13.339,13.339,0,0,0,1.805-26.559ZM46.112,48.09H19.371A8,8,0,0,1,16.79,32.508a2.637,2.637,0,0,0,2.581,2.211,2.673,2.673,0,0,0,2.674-2.674,10.7,10.7,0,1,1,21.393,0,2.673,2.673,0,0,0,2.674,2.674,2.637,2.637,0,0,0,2.581-2.211A8,8,0,0,1,46.112,48.09Z",
    transform: "translate(6.697 23.438)",
    fill: "#7b7bff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeM);
export default __webpack_public_path__ + "static/media/DE_M.5218d61b5f74ee2a291ef5eebc4b80dc.svg";
export { ForwardRef as ReactComponent };